export var getInitialMaskValue = function getInitialMaskValue(mask) {
  var defaultMaskChar = '_';
  return mask.replace(/[9a*]/g, defaultMaskChar);
};